import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthStateStore } from './auth-state.store';

const REDIRECT_URL_KEY = 'auth_redirect_url';

export const nativeAuthGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const authStore = inject(AuthStateStore);
  const router = inject(Router);

  authStore.registerAfterSignInCallback('auth-guard-redirect', () => {
    authStore.unregisterAfterSignInCallback('auth-guard-redirect');
    const redirectUrl = sessionStorage.getItem(REDIRECT_URL_KEY);
    if (redirectUrl) {
      sessionStorage.removeItem(REDIRECT_URL_KEY);

      // Use setTimeout to ensure navigation happens after the current change detection cycle
      setTimeout(() => {
        router.navigateByUrl(redirectUrl).catch((error) => {
          console.error('Failed to redirect after sign-in:', error);
        });
      }, 0);
    }
  });

  // Check if user is authenticated
  const isAuthenticated = authStore.isAuthenticated();

  // If authenticated, allow access
  if (isAuthenticated) {
    return true;
  }

  // User is not authenticated - store the intended destination
  const redirectUrl = state.url;

  // Only store non-empty URLs that aren't the root
  if (redirectUrl && redirectUrl !== '/') {
    console.log('Storing redirect URL:', redirectUrl);
    sessionStorage.setItem(REDIRECT_URL_KEY, redirectUrl);
  }

  // Trigger sign-in flow
  authStore.signIn();

  // Prevent navigation to the protected route
  // User will be automatically redirected after successful sign-in via the registered callback
  return false;
};
